import React from 'react';
import './description.scss';
import ResponsiveImage from 'shared/responsive-image/responsive-image';

export function Description() {
  return (
    <div>
      <div className="container margin_120_95">
        <div className="main_title">
          <h1>УЗ «Пинский диспансер спортивной медицины»</h1>
          <p>
            Наш спортивный диспансер входит в семёрку лучших диспансеров страны.
          </p>
        </div>
        <div className="row justify-content-between">
          <div className="clearfix">
            <figure>
              <ResponsiveImage
                src="/v1555154910/home/pdsm-side2019.jpg"
                className="float-end add_left_15 add_bottom_30 img-thumbnail"
                alt=""
                width={6000}
                height={4000}
              />
            </figure>
            <p>
              Осмотр учащихся ДЮСШ и высококвалифицированных спортсменов,
              углубленный медосмотр студентов профтехучилищ, средних и высших
              учебных заведений, обслуживание спортивных мероприятий.
            </p>
            <p>
              <em>Главврач Пётр Хлебус</em>
            </p>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Description;
